export default __webpack_public_path__ + "static/media/no-payments.61425a8f.svg";